export function loadStyleSheet(themeUrl: string) {
  if (document.getElementById('globalTheme')) {
    document.getElementById('globalTheme')?.remove();
  }
  const styleElement = document.createElement('link');
  styleElement.setAttribute('id', 'globalTheme');
  styleElement.setAttribute('rel', 'stylesheet');
  styleElement.setAttribute('href', `${themeUrl}`);
  // Append the style element to the document's head
  document.head.appendChild(styleElement);
}

/**
 * Transforms raw CSS by prepending the dynamic ID/Selector to each existing selector.
 * @param css - The raw CSS string
 * @param id - The dynamic ID/Selector to prepend
 * @returns Transformed CSS string
 */
export function transformCSSWithDynamicSelector(css: string, id: string): string {
  // Use regex to prepend the ID to each selector
  return css.replace(/(^|\})\s*([^{]+)/g, (_, closeBrace, selector) => {
    const scopedSelector = selector
      .split(',')
      .map((s: string) => `${id} ${s.trim()}`)
      .join(', ');
    return `${closeBrace} ${scopedSelector}`;
  });
}

/**
 * Validates if the provided CSS string contains valid and non-empty CSS rules
 * @param cssString The CSS string to validate
 * @returns boolean indicating if the CSS is valid and contains non-empty rules
 */
export function isValidCSS(cssString: string): boolean {
  if (!cssString || typeof cssString !== 'string' || !cssString.trim()) {
    return false;
  }

  // Remove comments to avoid false positives
  const cssWithoutComments = cssString.replace(/\/\*[\s\S]*?\*\//g, '');

  // Check for empty rule sets (e.g., ".selector {}" or ".selector { }")
  const hasEmptyRules = /[^{}]*\{\s*\}/.test(cssWithoutComments);
  if (hasEmptyRules) {
    return false;
  }

  // Check for valid CSS rules with actual content
  const hasValidRules = /[^{}]*\{[^}]+\}/.test(cssWithoutComments);
  if (!hasValidRules) {
    return false;
  }

  return true;
}
